var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6292 28H0.619028C0.27716 28 0 27.7264 0 27.3889V0.611092C0 0.273525 0.27716 0 0.619028 0H23.6292C23.9711 0 24.2483 0.273525 24.2483 0.611092V27.3889C24.2483 27.7264 23.9711 28 23.6292 28ZM1.23806 26.7778H23.0102V1.22218H1.23806V26.7778Z",
    fill: "#A9A7A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.3263 6.23439H4.92152C4.57965 6.23439 4.30249 5.96079 4.30249 5.6233C4.30249 5.28573 4.57965 5.01221 4.92152 5.01221H19.3263C19.6682 5.01221 19.9453 5.28573 19.9453 5.6233C19.9453 5.96079 19.6682 6.23439 19.3263 6.23439Z",
    fill: "#A9A7A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.3263 9.41945H4.92152C4.57965 9.41945 4.30249 9.14593 4.30249 8.80836C4.30249 8.47079 4.57965 8.19727 4.92152 8.19727H19.3263C19.6682 8.19727 19.9453 8.47079 19.9453 8.80836C19.9453 9.14593 19.6682 9.41945 19.3263 9.41945Z",
    fill: "#A9A7A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.3263 12.6045H4.92152C4.57965 12.6045 4.30249 12.331 4.30249 11.9934C4.30249 11.6558 4.57965 11.3823 4.92152 11.3823H19.3263C19.6682 11.3823 19.9453 11.6558 19.9453 11.9934C19.9453 12.331 19.6682 12.6045 19.3263 12.6045Z",
    fill: "#A9A7A7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.3264 15.7896H15.1425C14.8006 15.7896 14.5234 15.516 14.5234 15.1785C14.5234 14.8409 14.8006 14.5674 15.1425 14.5674H19.3264C19.6682 14.5674 19.9454 14.8409 19.9454 15.1785C19.9454 15.516 19.6682 15.7896 19.3264 15.7896Z",
    fill: "#A9A7A7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.5535 25.2604L10.1823 20.5699C10.7955 19.9879 11.1783 19.171 11.1783 18.2669C11.1783 16.5043 9.72569 15.0703 7.94025 15.0703C6.1548 15.0703 4.70223 16.5043 4.70223 18.2669C4.70223 19.171 5.08504 19.988 5.69829 20.57L4.32702 25.2604C4.25785 25.4972 4.3394 25.7517 4.53394 25.9061C4.64627 25.9953 4.78361 26.041 4.92186 26.041C5.02297 26.041 5.12449 26.0165 5.21718 25.9669L7.94033 24.5072L10.6635 25.9669C10.7561 26.0165 10.8577 26.041 10.9587 26.041C11.097 26.041 11.2344 25.9953 11.3467 25.9061C11.5412 25.7518 11.6227 25.4973 11.5535 25.2604ZM7.94033 16.2925C9.04311 16.2925 9.94037 17.1783 9.94037 18.2669C9.94037 19.3555 9.04311 20.2411 7.94033 20.2411C6.83755 20.2411 5.94037 19.3555 5.94037 18.2669C5.94029 17.1783 6.83747 16.2925 7.94033 16.2925ZM8.23565 23.2749C8.04598 23.1733 7.82634 23.1798 7.64905 23.2729C7.64765 23.2736 7.64625 23.2742 7.64493 23.2749L5.92692 24.1958L6.7872 21.2532C7.14566 21.3885 7.53425 21.4634 7.94033 21.4634C8.34641 21.4634 8.735 21.3885 9.09345 21.2532L9.95374 24.1958L8.23565 23.2749Z",
    fill: "#A9A7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentsIcon);
export default __webpack_public_path__ + "static/media/AttachmentsIcon.b976d6566c2f52f550776db35e91e243.svg";
export { ForwardRef as ReactComponent };